import { Grid, Typography } from "@mui/material";
import ActionItem from "../ActionItem/ActionItem";
import { useState } from "react";
import RequestModal from "./RequestModal";

export default function Request() {
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [isHardware, setIsHardware] = useState(false);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component={"h4"} variant={"h3"} color={"primary.main"}>
            Request
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Hardware"}
            onClick={() => {
              setShowRequestModal(true);
              setIsHardware(true);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Accessory"}
            onClick={() => {
              setShowRequestModal(true);
              setIsHardware(false);
            }}
          />
        </Grid>
      </Grid>
      <RequestModal
        isOpen={showRequestModal}
        onClose={() => setShowRequestModal(false)}
        isHardware={isHardware}
      />
    </>
  );
}
